module.exports = __webpack_public_path__ + "static/media/total_users.56daa3db.svg";